import { useCallback, useMemo } from "react";
import { useCachedNumberFormat } from "./useCachedNumberFormat";
function useNumberParserFromSeparators(options) {
    const { thousandSeparator, decimalSeparator } = options;
    // return a memoized function for parsing numbers
    return useCallback((text) => {
        if (!text) {
            return [false, NaN];
        }
        // replace decimal and thousand separator
        const parsableNumber = text
            .replace(new RegExp(`\\${thousandSeparator}`, "g"), "")
            .replace(new RegExp(`\\${decimalSeparator}`), ".");
        // parse the number
        const parsedNumber = Number(parsableNumber);
        // check if it is the same
        const isValidNumber = !isNaN(parsedNumber) && String(parsedNumber) === parsableNumber;
        return [isValidNumber, isValidNumber ? parsedNumber : NaN];
    }, [thousandSeparator, decimalSeparator]);
}
/**
 * Returns a function for parsing numbers, using the current configuration language
 * @category Hook
 * @see https://stackoverflow.com/a/29273131
 * @param numberFormat We need grouping for parsing the separators
 * @param options
 * @returns the number parser function
 */
export function useNumberParserFromIntlNumberFormat(numberFormat) {
    // detect decimal and thousand separator
    const separators = useMemo(() => {
        return {
            thousandSeparator: numberFormat.format(1234).replace(/[0-9]/g, ""),
            decimalSeparator: numberFormat.format(123.4).replace(/[0-9]/g, ""),
        };
    }, [numberFormat]);
    return useNumberParserFromSeparators(separators);
}
/**
 * Returns a function for parsing numbers, using the current configuration language
 * @category Hook
 * @see https://stackoverflow.com/a/29273131
 * @param localeCode
 * @param options Currently unused
 * @returns the number parser function
 */
export function useNumberParserFromIntlNumberFormatOptions(localeCode, _options) {
    // we need grouping for parsing the separators
    const formatWithGrouping = useMemo(() => ({ useGrouping: true, maximFractionDigits: 2 }), []);
    const numberFormat = useCachedNumberFormat(localeCode, formatWithGrouping);
    return useNumberParserFromIntlNumberFormat(numberFormat);
}
//# sourceMappingURL=useNumberParserFromIntlNumberFormat.js.map